import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLayout } from "../../context/LayoutContext";
import ReviewBell from "../review/ReviewBell";
import ROUTES from "../../constants/routes";
import "./header.scss";

function MenuIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 7H20M4 12H20M4 17H20" stroke="#914985" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { toggleSidebar } = useLayout();

  const fullName = user ? `${user.firstName} ${user.lastName}` : "معلم";

  const handleLogout = () => {
    logout();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  return (
    <header className="header">
      <div className="header__start">
        <button
          type="button"
          className="header__menu-btn"
          onClick={toggleSidebar}
          aria-label="باز کردن منو"
        >
          <MenuIcon />
        </button>

        <div className="header__logo">
          <img className="object-cover h-full" src="/images/logo.png" alt="logo" />
        </div>

        <div className="header__meta">
          <p className="text-[12px]">شماره کاربری: {user?.phone || "—"}</p>
          <p className="text-[12px]">کد ملی: {user?.nationalCode || "—"}</p>
          <p className="text-[12px]">نقش: معلم</p>
        </div>
      </div>

      <div className="header__end">
        <ReviewBell />

        <div className="header__avatar">
          {user?.avatar ? (
            <img src={user.avatar} alt={fullName} className="w-full h-full object-cover" />
          ) : (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23.6023 17.5366L17.6116 20.4069C16.7199 20.8342 15.7009 20.8883 14.7773 20.5678L14.3882 20.4069L8.39762 17.5366V21.1851C8.39763 22.1776 8.89899 23.1026 9.73042 23.6445L10.7585 24.3147L11.0585 24.5022C14.1998 26.3883 18.1558 26.3262 21.243 24.3147L22.2695 23.6445L22.5663 23.4242C23.2191 22.8704 23.6023 22.0533 23.6023 21.1851V17.5366ZM28.2695 20.0006V15.3007L25.7305 16.5163V21.1851C25.7303 22.7901 24.9699 24.2928 23.6929 25.2445L23.4319 25.4272L22.4039 26.0976C18.6331 28.5544 13.8019 28.6306 9.9648 26.3272L9.59605 26.0976L8.56949 25.4272C7.13509 24.4926 6.26951 22.8971 6.26949 21.1851V16.5163L2.04917 14.496C0.234198 13.6262 0.234324 11.0409 2.04917 10.171L14.3882 4.25853L14.7773 4.09915C15.7008 3.77869 16.7199 3.83147 17.6116 4.25853L29.9507 10.171L30.1148 10.2585C31.6097 11.1137 31.7039 13.2079 30.3975 14.2195V20.0006C30.3972 20.588 29.9209 21.0632 29.3335 21.0632C28.7462 21.0632 28.2699 20.588 28.2695 20.0006ZM16.6929 6.17883C16.3095 5.99514 15.8712 5.97211 15.4742 6.11008L15.307 6.17883L2.96949 12.0898C2.76555 12.1875 2.76555 12.478 2.96949 12.5757L15.307 18.4882L15.4742 18.557C15.8712 18.6949 16.3095 18.6718 16.6929 18.4882L29.0305 12.5757L29.0975 12.532C29.2129 12.4271 29.2127 12.2401 29.0975 12.1351L29.0305 12.0898L16.6929 6.17883Z"
                fill="#914985"
              />
            </svg>
          )}
        </div>

        <div className="header__user">
          <p className="text-[14px] yekanSemiBold">{fullName}</p>
          <button
            type="button"
            onClick={handleLogout}
            className="text-[12px] text-[#FF420E] yekanSemiBold"
          >
            خروج
          </button>
        </div>
      </div>
    </header>
  );
}
